<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h3>Select Cameras</h3>
            </div>
            <div class="card-body">
                <p><b>Select the camera location(s) for the video(s) you are requesting.</b> To make a selection, zoom
                    to an area on the map manually or use one of the metro area preset buttons below. Individually click
                    on the camera(s) you would like, or use one of the options (orange buttons below). </p>
                <h4>SELECTION OPTIONS</h4> <button type="button" id="deselecter" class="btn btn-warning"
                    (click)="clearAllCameras()">De-select all Cameras</button> <button type="button" id="all_selecter"
                    class="btn btn-warning" (click)="selectCamerasInView()">Select all Cameras Currently in
                    View</button> <button type="button" id="draw_selecter" class="btn btn-warning"
                    (click)="extentCameras()">Select a rectangular region of the map</button>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12" id="select_cameras">
        <div #mapViewNode></div>
        <!--class="mb-5 mt-5" style="z-index: 100;"--> 
            <div id="paneDiv" class="mb-1 mt-1" [hidden]="!_loaded"> <button (click)="metroClick('Ames')"
                class="esri-button esri-button-overwrite">Ames</button> <button (click)="metroClick('Council Bluffs')"
                class="esri-button esri-button-overwrite">Council Bluffs</button> <button
                (click)="metroClick('Des Moines')" class="esri-button esri-button-overwrite">Des Moines</button> <button
                (click)="metroClick('Iowa City')" class="esri-button esri-button-overwrite">Iowa City</button> <button
                (click)="metroClick('Sioux City')" class="esri-button esri-button-overwrite">Sioux City</button> <button
                (click)="metroClick('Quad Cities')" class="esri-button esri-button-overwrite">Quad Cities</button>
            <button (click)="metroClick('Waterloo')" class="esri-button esri-button-overwrite">Waterloo</button>
            <button (click)="resetMap()" class="esri-button esri-button-overwrite">Reset</button> </div>       
    </div>
</div>
<!-- <div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h3>Instructions</h3>
            </div>
            <div class="card-body">

        <p style="z-index: 100;"> <b>Instructions</b> <br /> <b>Click</b> the
            <b>camera</b> graphic to select or unselect. <br /> Follow the page below to fill out your contact
            information.<br /> </p>
</div>
</div>
    </div>
</div> -->